import React from 'react'
import { Pressable, StyleSheet } from 'react-native'

import { useNavigation, useRoute } from '@react-navigation/native'
import { FlashList } from '@shopify/flash-list'
import { colors, Icon, Stack, XStack } from '@zet/design-system'
import { B1, B4, B5, H5 } from '@zet/design-system/typography'
import { Control } from 'react-hook-form'

import { brandsI18n } from '../../localization'
import { UserDetailsProps } from '../../types'
import { IOcField } from '../../utils/types'
import DocumentUploadGuidelines from '../common/DocumentUploadGuidelines'
import FormController from './formController'

interface Props {
  ocFields: IOcField[]
  title?: string
  subTitle?: string
  control: Control
  uploadGuidelines: any
  userDetails: UserDetailsProps
  state: any
  prevState?: string
  arnNumber?: string
}

const Form: React.FC<Props> = (props) => {
  const {
    ocFields,
    title,
    subTitle,
    control,
    uploadGuidelines,
    userDetails,
    state,
    prevState,
    arnNumber,
  } = props
  const navigation = useNavigation()
  const { params } = useRoute()
  const { hash } = params || {}

  const goToPrevState = () => {
    navigation.replace('BrandsCC', {
      state: prevState,
      hash,
    })
  }

  return (
    <>
      <FlashList
        data={ocFields}
        contentContainerStyle={styles.container}
        estimatedItemSize={10}
        ListHeaderComponent={() => (
          <>
            {prevState ? (
              <Stack className="mb-3 items-start">
                <Pressable
                  className="rounded bg-[#F5F7FB] p-1"
                  onPress={goToPrevState}
                >
                  <Icon type="ArrowLeft" color="#2F3440" />
                </Pressable>
              </Stack>
            ) : null}
            {!!title && (
              <H5 className={`${prevState ? '' : 'mt-4'} pr-3`}>{title}</H5>
            )}
            {!!subTitle && <B1 className="text-grays-70 pr-3">{subTitle}</B1>}
            {!!arnNumber && (
              <XStack className="bg-grays-20 mx-3 mt-4 items-center rounded p-2">
                <Icon
                  type="DocumentOutlined"
                  size={16}
                  color={colors.primary[200]}
                />
                <B5 className="text-primary-200 px-2">
                  {brandsI18n.t('hdfc.application')}
                </B5>
                <B4 className="text-primary-200">{arnNumber}</B4>
              </XStack>
            )}
          </>
        )}
        renderItem={({ item }) => (
          <FormController
            userDetails={userDetails}
            control={control}
            ocField={item}
            state={state}
          />
        )}
        ListFooterComponent={
          uploadGuidelines ? (
            <Stack className="mt-3 border-t-2 border-dashed border-[#D1D9E9] pt-1">
              <DocumentUploadGuidelines
                guidelines={uploadGuidelines?.guidelines}
                title={uploadGuidelines?.title}
              />
            </Stack>
          ) : null
        }
      />
    </>
  )
}

export default Form

const styles = StyleSheet.create({
  container: {
    padding: 16,
    paddingTop: 12,
  },
})
